const state = () => ({
  list: null,
  exam: null,
})

const getters = {
  list: (state) => state.list,
  exam: (state) => state.exam,
}

const mutations = {
  receiveList(state, list) {
    state.list = list
  },
  receiveExam(state, exam) {
    state.exam = exam
  },
}

const actions = {
  getList({ commit, rootState }, patientId) {
    return this.$axios
      .post('/fitness-app-backend/v1/app/circumferences/list', {
        accessToken: rootState.user.token,
        patientId,
        filters: {
          singleOnly: true,
        },
      })
      .then((response) => {
        commit('receiveList', response.data.circumferences)
      })
  },
  getExam({ commit, rootState }, examId) {
    return this.$axios
      .post('/fitness-app-backend/v1/app/circumferences/get', {
        accessToken: rootState.user.token,
        id: examId,
      })
      .then((response) => {
        commit('receiveExam', response.data.circumference)
        return response
      })
  },
  createExam({ dispatch, rootState, rootGetters }, exam) {
    const currentExam = Object.assign({}, exam)
    return this.$axios
      .post('/fitness-app-backend/v1/app/circumferences/create', {
        accessToken: rootState.user.token,
        circumference: currentExam,
      })
      .then((response) => {
        if (!rootGetters['profile/wizard']) {
          dispatch('getList', exam.patientId)
        }
        if (rootState.profile.isBaseline) {
          dispatch('profile/getProfile', exam.patientId, { root: true })
        }
        return response
      })
  },
  updateExam({ dispatch, rootState }, exam) {
    const currentExam = Object.assign({}, exam)
    return this.$axios
      .post('/fitness-app-backend/v1/app/circumferences/update', {
        accessToken: rootState.user.token,
        circumference: currentExam,
      })
      .then(() => {
        dispatch('getExam', exam.id)
        if (rootState.profile.isBaseline) {
          dispatch('profile/getProfile', exam.patientId, { root: true })
        }
      })
  },
  deleteExam({ rootState }, examId) {
    return this.$axios.post(
      '/fitness-app-backend/v1/app/circumferences/delete',
      {
        accessToken: rootState.user.token,
        id: examId,
      }
    )
  },
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
}
